__turbopack_context__.v({
  "cardsContainer": "OtherProductsSection-module__tGmxEq__cardsContainer",
  "container": "OtherProductsSection-module__tGmxEq__container",
  "productActions": "OtherProductsSection-module__tGmxEq__productActions",
  "productContent": "OtherProductsSection-module__tGmxEq__productContent",
  "productDescription": "OtherProductsSection-module__tGmxEq__productDescription",
  "productItem": "OtherProductsSection-module__tGmxEq__productItem",
  "productTitle": "OtherProductsSection-module__tGmxEq__productTitle",
  "root": "OtherProductsSection-module__tGmxEq__root",
});
